/* eslint-disable sort-keys, max-len */
export default {
    // bidding console
    bidding_console: {
        console: {
            button: {
                login: 'Zaloguj się na Licytację',
                signup: 'Zarejestruj się na Licytację',
                register_long: 'Rejestracja na Aukcję',
                pending: 'Rejestracja Oczekuje',
                declined: 'Rejestracja Odrzucona',
                closed: 'Licytacja zamknięta',
                sent: 'Twója oferta została wysłana',
                outbid: 'Zostałeś przelicytowany, stawka {amount}',
                bid: 'Stawka {amount}',
                winning: 'Wygrywasz',
            },
            conversions: {
                lot_number: 'ARTYKUŁ {lotNumber}',
            },
            description: {
                estimate_range: 'Szacunek {low} - {high}',
                images_label: '{currentImageNumber} / {totalImages}',
            },
            messages: {
                competing_bid_amount: '{amount}: Konkurencyjna stawka',
                competing_bidder_outbid_by_liveauctioneers_absentee:
                    'Konkurencyjny licytujący został przelicytowany przez stawkę nieobecnego licytującego {paddleNumber}',
                last_bid_retracted: 'Ostatnia stawka {amount} wycofana',
                liveauctioneers_bid_amount: '{amount}: Licytujący na żywo {paddleNumber}',
                liveauctioneers_bid_amount_absentee: '{amount}: Licytujący na żywo stawka licytującego {paddleNumber}',
                lot_number_passed: 'Artykuł {lotNumber} zaksięgowany',
                lot_number_reopened: 'Artykuł {lotNumber} otwarty ponownie',
                lot_number_skipped: 'Artykuł {lotNumber} ominięty',
                lot_number_unsold: 'Artykuł {lotNumber} niesprzedany',
                lot_opened_asking: 'Artykuł {lotNumber} otwarto - stawka {amount}',
                lot_sold_competing_bidder: 'Artykuł {lotNumber} sprzedany za {amount} konkurencyjnemu licytującemu',
                lot_sold_liveauctioneers_bidder:
                    'Artykuł {lotNumber} sprzedany za {amount} licytującemu {paddleNumber}',
                my_bid_amount: '{amount}: moja stawka',
                my_bid_amount_absentee: '{amount}: stawka nieobecnego',
                my_bid_retracted: 'Twoja stawka {amount} została wycofana',
                registration_approved: 'Twoja rejestracja została zaakceptowana',
                reserve_not_met: 'Poniżej rezerwy',
                you_been_outbid_by_liveauctioneers_absentee:
                    'Zostałeś przelicytowany przez stawkę nieobecnego licytującego {paddleNumber}',
                you_ve_won_lot: 'Wygrałeś artykuł {lotNumber}',
            },
            missives: {
                fair_warning_lot_about_to_close: 'Ostrzeżenie... Ten artykuł wkrótce zostanie zamknięty',
                going_once_going_twice: 'PO RAZ PIERWSZY... PO RAZ DRUGI...',
                third_and_final_warning: 'TRZECIE I OSTATNIE OSTRZEŻENIE...',
            },
            status: {
                remaining: '{remaining} z {total} artykułów pozostało',
            },
            thumbnail_scroller: {
                next: 'Następne artykuły',
            },
        },
    },
};
